import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { Poker2SoundController } from "../../controller/Poker2SoundController";
import { Poker2Dialog } from "./Poker2Dialog";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2WarningDialog extends Poker2Dialog {
    public static NAME: string = "Poker2WarningDialog";

    constructor(disp: Container) {
        super(disp);
    }
    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        this.controller.soundController.playSoundEffectByName(Poker2SoundController.SND_WARN);

        this.standardDialog.btn_ok.label = this.standardDialogProperties.buttonLabel_ok;
        this.standardDialog.txt_title.text = this.standardDialogProperties.title;
        this.standardDialog.txt_copy.text = this.standardDialogProperties.copy;
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.standardDialog.btn_close:
            case this.standardDialog.btn_ok:
                this.hide();
                if (this.standardDialogProperties.functionOk != null)
                    this.standardDialogProperties.functionOk(null);
                break;
        }
    }

    protected get standardDialogProperties(): BasicStandardOkDialogProperties {
        return this.properties as BasicStandardOkDialogProperties;
    }

    protected get standardDialog(): Library.PokerInterface.PokerStandardOk {
        return this.disp as Library.PokerInterface.PokerStandardOk;
    }
}
